module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.pagina.better_featured_image.source_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.pagina.title.rendered)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.pagina.content.rendered)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7848970a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_iconos.vue
// module id = 143
// module chunks = 0